import { Dialog, styled } from '@mui/material';

const PREFIX = 'SelectionModal';

export const selectionModalClasses = {
  actionButtonsContainer: `${PREFIX}-actionButtonsContainer`,
  textDescription: `${PREFIX}-textDescription`,
  checkbox: `${PREFIX}-checkbox`,
  checkboxLabel: `${PREFIX}-checkboxLabel`,
  actionButton: `${PREFIX}-actionButton`,
};

export const StyledSelectionModalDialog = styled(Dialog)(({ theme }) => ({
  [`& .${selectionModalClasses.actionButtonsContainer}`]: {
    padding: '2rem',
    justifyContent: 'center',
  },

  [`& .${selectionModalClasses.textDescription}`]: {
    color: theme.palette.black,
    fontSize: '0.875rem',
  },

  [`& .${selectionModalClasses.checkbox}`]: {
    color: theme.palette.grey[300],
  },

  [`& .${selectionModalClasses.checkboxLabel}`]: {
    fontSize: 16,
    fontWeight: 600,
  },

  [`& .${selectionModalClasses.actionButton}`]: {
    padding: '0.5rem 2rem',
    fontWeight: 600,
    fontSize: '1rem',
  },
}));